<!-- Toast tasa cambiada -->
<div *ngIf="showRateChangedWarning" class="rate-toast">
  <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: white;">warning</mat-icon>
  <span style="font-size: 0.82rem; font-weight: 600; line-height: 1.4;">La tasa ha cambiado. Se actualizaron los montos.</span>
</div>

<div class="px-2 sm:px-4 md:px-8 py-4 sm:py-6" style="max-width: 520px; margin: 0 auto;">

  <!-- Header -->
  <div class="ves-header" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 14px 16px; margin-bottom: 16px;">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
      <button type="button" class="btn-tactil" (click)="goBack()"
        [disabled]="isTransitioning || isConverting"
        [style.opacity]="(isTransitioning || isConverting) ? '0.5' : '1'"
        [style.cursor]="(isTransitioning || isConverting) ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
        onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #374151;">arrow_back</mat-icon>
        <span class="hidden sm:inline">Atrás</span>
      </button>
      <span style="background: #1C593D; color: white; padding: 4px 14px; border-radius: 20px; font-size: 0.8rem; font-weight: 700;">
        Paso {{ step }}/{{ totalSteps }}
      </span>
    </div>
    <div style="width: 100%; height: 8px; background: #dcfce7; border-radius: 20px; overflow: hidden;">
      <div style="height: 100%; background: #1C593D; border-radius: 20px; transition: width 0.3s ease;"
        [style.width.%]="(step / totalSteps) * 100"></div>
    </div>
  </div>

  <!-- ===== STEP 1: Calculadora ===== -->
  <div *ngIf="step === 1" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 16px;">
      <h2 class="ves-title" style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Comprar USDT con VES</h2>
      <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">Calcula tu conversión en tiempo real</p>
    </div>

    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">
      <!-- Tasa vigente -->
      <div class="ves-rate-bar" style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 12px 16px; border-bottom: 2px solid #bbf7d0; text-align: center;">
        <div *ngIf="!loadingRate && !rateError">
          <div style="display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover;">
            <span class="ves-rate-text" style="font-size: 1rem; font-weight: 800; color: #1e5a3f;">{{ formatVESNumber(tasaVesUsdt) }} VES = 1 USDT</span>
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover;">
          </div>
        </div>
        <div *ngIf="loadingRate" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <mat-spinner diameter="18"></mat-spinner>
          <span style="font-size: 0.82rem; color: #6b7280;">Cargando tasa...</span>
        </div>
        <div *ngIf="rateError && !loadingRate" style="font-size: 0.82rem; color: #dc2626; font-weight: 600;">{{ rateError }}</div>
      </div>

      <div class="ves-card-body" style="padding: 16px;">
        <!-- Saldos -->
        <div class="grid grid-cols-2 gap-2 sm:gap-3" style="margin-bottom: 14px;">
          <div class="ves-saldo-card" style="display: flex; flex-direction: column; align-items: center; padding: 10px 8px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px;">
            <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280;">Saldo VES</span>
            </div>
            <span class="ves-saldo-amount" style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">{{ formatVES(saldoVes) }}</span>
          </div>
          <div class="ves-saldo-card" style="display: flex; flex-direction: column; align-items: center; padding: 10px 8px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px;">
            <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
              <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280;">Saldo USDT</span>
            </div>
            <span class="ves-saldo-amount" style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">{{ formatUSDTWithSymbol(saldoUsdt) }}</span>
          </div>
        </div>

        <!-- Mensajes -->
        <div *ngIf="tienesSaldoVes && !errorMessage"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">info</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Monto mínimo a recibir: <strong>{{ MIN_USDT_AMOUNT }} USDT</strong></span>
        </div>

        <div *ngIf="!tienesSaldoVes"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
          <span *ngIf="ofreceRecargaVes" style="font-size: 0.78rem; font-weight: 600; color: #92400e;">Saldo VES insuficiente. <strong>Recarga tu cuenta VES</strong> para comprar USDT</span>
          <!-- 30/10/2026: el chileno no recarga bolívares; no se le sugiere. -->
          <span *ngIf="!ofreceRecargaVes" style="font-size: 0.78rem; font-weight: 600; color: #92400e;">Saldo VES insuficiente. No tienes bolívares disponibles para comprar USDT.</span>
        </div>

        <div *ngIf="errorMessage && tienesSaldoVes"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">{{ errorMessage }}</span>
        </div>

        <div *ngIf="!isOperatingHours"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">schedule</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">Fuera de horario. Operamos de <strong>{{ horarioOperacion }}</strong> (hora Venezuela)</span>
        </div>

        <!-- Input VES (envías) -->
        <div style="margin-bottom: 14px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.78rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
            Tú envías (VES)
          </label>
          <div style="position: relative;">
            <span class="input-currency-label" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.78rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 3px;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
              VES
            </span>
            <!-- `type=text` + `appMonto`: separador de miles en vivo. Es donde
                 más se nota — los montos en bolívares tienen muchos dígitos. -->
            <input type="text" inputmode="numeric" appMonto [decimales]="2"
              [(ngModel)]="montoVes"
              (ngModelChange)="calcularDesdeVes()"
              placeholder="0"
              [disabled]="!isOperatingHours"
              class="calc-input"
              style="width: 100%; padding: 12px 70px 12px 62px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
            <button type="button" class="btn-tactil"
              [disabled]="!isOperatingHours || !tienesSaldoVes"
              (click)="usarMaximo()"
              [style.opacity]="(!isOperatingHours || !tienesSaldoVes) ? '0.5' : '1'"
              style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 10px; font-size: 0.72rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              MÁX
            </button>
          </div>
        </div>

        <!-- Arrow -->
        <div style="display: flex; justify-content: center; margin-bottom: 12px;">
          <div style="width: 36px; height: 36px; background: #1C593D; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">arrow_downward</mat-icon>
          </div>
        </div>

        <!-- Output USDT (recibes) -->
        <div style="margin-bottom: 14px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.78rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
            Recibes (USDT)
          </label>
          <div style="position: relative;">
            <span class="input-currency-label" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.78rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 3px;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 14px; height: 14px; border-radius: 50%; object-fit: cover;">
              USDT
            </span>
            <input type="text" inputmode="numeric" appMonto [decimales]="2"
              [(ngModel)]="montoUsdt"
              (ngModelChange)="calcularDesdeUsdt()"
              placeholder="0.00"
              [disabled]="!isOperatingHours"
              class="calc-input"
              style="width: 100%; padding: 12px 16px 12px 68px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
          </div>
        </div>

        <!-- Tu tasa: la del tramo del monto (sin tramos, la base de siempre).
             Con escalera la pinta `app-escalera-tramos`, más abajo. -->
        <div *ngIf="tasaVesUsdt > 0 && !loadingRate && !escaleraVes"
          style="display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; font-size: 0.82rem;">
          <span style="color: #4b5563; font-weight: 500;">{{ tramosSinActualizar ? 'Tasa estimada' : 'Tu tasa' }}</span>
          <span style="display: flex; align-items: center; gap: 8px;">
            <strong style="color: #1e5a3f;">{{ formatVESNumber(tasaVesUsdt) }} VES/USDT</strong>
          </span>
        </div>

        <!-- Tramos sin actualizar: se cobra la base como tasa estimada -->
        <p *ngIf="tramosSinActualizar && tasaVesUsdt > 0 && !loadingRate"
          style="margin: -6px 0 12px; font-size: 0.72rem; color: #6b7280;">
          No pudimos actualizar los tramos; la tasa final se confirma al comprar.
        </p>

        <!-- Escalera de tramos: «Tu tasa», «Tramo k de N», el ahorro, lo que
             falta y la lista plegada. Reemplaza la nota de ahorro y la lista
             «Compra más, paga menos». Sin escalera no se dibuja nada. En el
             celular acá va solo el teaser de una línea; la completa, debajo
             del botón. Formato en-US, el del campo de monto. -->
        <app-escalera-tramos
          *ngIf="tasaVesUsdt > 0 && !loadingRate && escaleraVes as esc"
          class="ves-escalera"
          style="margin-bottom: 16px;"
          posicion="arriba"
          locale="en-US"
          [escalera]="esc"
          [monto]="montoVes"
          moneda="VES"
          monedaDestino="USDT"
          tipoAhorro="PAGA_MENOS"
          decimales="1.2-2"
          [base]="baseEscaleraVes"
          [precioCorte]="tramosData?.precioCorte"
          [tasaAplicada]="tasaVesUsdt"
          [tasaReferencia]="baseEscaleraVes"
          simbolo="Bs."
          unidad="Bs. por 1 USDT"
          idBase="esc-ves-usdt"
          [compacta]="true"
          [permitirUsar]="isOperatingHours"
          [montoMaximo]="saldoVes"
          (usarMonto)="usarMontoVes($event)"
        ></app-escalera-tramos>

        <!-- Detalles -->
        <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px;">
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px solid #e5e7eb;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
            <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Tipo de cambio:</span>
            <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ formatVESNumber(tasaVesUsdt) }} VES = 1 USDT</span>
          </div>
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">schedule</mat-icon>
            <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Horario:</span>
            <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ horarioOperacion }}</span>
          </div>
        </div>

        <!-- Confirmación monto -->
        <div *ngIf="montoUsdt >= MIN_USDT_AMOUNT && isValidAmount"
          style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">check_circle</mat-icon>
          <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Recibirás <strong>{{ formatUSDTWithSymbol(montoUsdt) }}</strong></span>
        </div>

        <!-- Botón -->
        <button type="button" (click)="openDestinationModal()"
          [disabled]="!isValidAmount || isTransitioning || isModalOpen"
          [style.opacity]="(!isValidAmount || isTransitioning || isModalOpen) ? '0.5' : '1'"
          [style.cursor]="(!isValidAmount || isTransitioning || isModalOpen) ? 'not-allowed' : 'pointer'"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
          onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
          Continuar
        </button>

        <!-- Celular (bajo 768 px): la escalera completa, debajo del botón. -->
        <app-escalera-tramos
          *ngIf="tasaVesUsdt > 0 && !loadingRate && escaleraVes as esc"
          class="ves-escalera"
          posicion="abajo"
          locale="en-US"
          [escalera]="esc"
          [monto]="montoVes"
          moneda="VES"
          monedaDestino="USDT"
          tipoAhorro="PAGA_MENOS"
          decimales="1.2-2"
          [base]="baseEscaleraVes"
          [precioCorte]="tramosData?.precioCorte"
          [tasaAplicada]="tasaVesUsdt"
          [tasaReferencia]="baseEscaleraVes"
          simbolo="Bs."
          unidad="Bs. por 1 USDT"
          idBase="esc-ves-usdt"
          [compacta]="true"
          [permitirUsar]="isOperatingHours"
          [montoMaximo]="saldoVes"
          (usarMonto)="usarMontoVes($event)"
        ></app-escalera-tramos>
      </div>
    </div>
  </div>

  <!-- ===== STEP 2 (wallet): Confirmación ===== -->
  <div *ngIf="step === 2 && destination === 'wallet'" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Confirmar Compra</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Revisa que todos los datos estén bien</p>
    </div>

    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
      <h3 style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Resumen de conversión</h3>

      <!-- Montos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Entregas</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatVESNumber(montoVes) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            VES
          </span>
        </div>
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Recibes</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatUSDT(montoUsdt) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            USDT
          </span>
        </div>
      </div>

      <!-- Destino -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">account_balance_wallet</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Destino:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">Wallet Aguacate</span>
      </div>

      <!-- Detalles -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tasa:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ formatVESNumber(tasaVesUsdt) }} VES/USDT</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">info</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Comisión:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ formatPct(comisionPct) }}</span>
      </div>
    </div>

    <!-- Botones -->
    <button type="button" (click)="confirmarCompra()"
      [disabled]="isConverting || isTransitioning || operationCompleted"
      [style.opacity]="(isConverting || isTransitioning || operationCompleted) ? '0.5' : '1'"
      [style.cursor]="(isConverting || isTransitioning || operationCompleted) ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s; margin-bottom: 10px;"
      onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isConverting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
      {{ isConverting ? 'Procesando...' : 'Confirmar Compra' }}
    </button>

    <button type="button" (click)="goBack()"
      [disabled]="isConverting || isTransitioning"
      [style.opacity]="(isConverting || isTransitioning) ? '0.5' : '1'"
      [style.cursor]="(isConverting || isTransitioning) ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: all 0.2s;"
      onmouseover="if(!this.disabled)this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">arrow_back</mat-icon>
      Volver
    </button>
  </div>

  <!-- ===== STEP 2 (withdraw): Selección de beneficiario ===== -->
  <div *ngIf="step === 2 && destination === 'withdraw'" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Selecciona un beneficiario</h2>
      <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">Elige la wallet destino para tu retiro</p>
    </div>

    <!--
      Red TRC20 pausada: el retiro sale solo por esa red. Los beneficiarios
      se siguen viendo, pero no se pueden elegir.
    -->
    <div *ngIf="!loadingBeneficiarios && avisoRedes" role="status"
      style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 14px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #b45309; margin-top: 1px;">pause_circle</mat-icon>
      <span style="font-size: 0.78rem; font-weight: 600; color: #92400e; line-height: 1.45;">{{ avisoRedes }}</span>
    </div>

    <!-- Loading -->
    <div *ngIf="loadingBeneficiarios" style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 40px 0;">
      <mat-spinner diameter="24"></mat-spinner>
      <span style="font-size: 0.85rem; color: #6b7280;">Cargando beneficiarios...</span>
    </div>

    <!-- Sin beneficiarios -->
    <div *ngIf="!loadingBeneficiarios && listaBeneficiarios.length === 0"
      style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 30px 20px; text-align: center; margin-bottom: 16px;">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">person_off</mat-icon>
      <p style="font-size: 0.9rem; font-weight: 700; color: #374151; margin: 0 0 6px;">
        {{ beneficiariosOtrasRedes > 0 ? 'No tienes beneficiarios en la red Tron (TRC20)' : 'No tienes beneficiarios cripto' }}
      </p>
      <p style="font-size: 0.78rem; color: #6b7280; margin: 0 0 14px;">
        {{ beneficiariosOtrasRedes > 0
          ? 'El retiro de USDT sale solo por la red Tron (TRC20). Agrega un beneficiario de esa red para retirar.'
          : 'Agrega un beneficiario para poder retirar tus USDT.' }}
      </p>
      <button type="button" (click)="abrirAgregarBeneficiario()"
        [disabled]="isTransitioning"
        [style.opacity]="isTransitioning ? '0.5' : '1'"
        [style.cursor]="isTransitioning ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s;"
        onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">person_add</mat-icon>
        Agregar Beneficiario
      </button>
    </div>

    <!-- Lista de beneficiarios -->
    <div *ngIf="!loadingBeneficiarios && listaBeneficiarios.length > 0">
      <!-- Búsqueda -->
      <div style="position: relative; margin-bottom: 14px;">
        <mat-icon style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">search</mat-icon>
        <input type="text"
          [(ngModel)]="searchBeneficiario"
          (ngModelChange)="buscarBeneficiario()"
          placeholder="Buscar beneficiario..."
          style="width: 100%; padding: 10px 14px 10px 38px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.85rem; color: #374151; background: white; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
          onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
      </div>

      <!-- Agregar beneficiario -->
      <button type="button" (click)="abrirAgregarBeneficiario()"
        [disabled]="isTransitioning"
        [style.opacity]="isTransitioning ? '0.5' : '1'"
        [style.cursor]="isTransitioning ? 'not-allowed' : 'pointer'"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 10px; background: white; color: #1C593D; border: 2px dashed #bbf7d0; border-radius: 12px; font-weight: 700; font-size: 0.82rem; cursor: pointer; transition: all 0.2s; margin-bottom: 12px;"
        onmouseover="if(!this.disabled){this.style.background='#f0fdf4';this.style.borderColor='#1C593D'}" onmouseout="this.style.background='white';this.style.borderColor='#bbf7d0'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">person_add</mat-icon>
        Agregar Beneficiario
      </button>

      <!-- Items -->
      <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px; max-height: 300px; overflow-y: auto;">
        <div *ngFor="let b of listaBeneficiariosFiltrados"
          class="beneficiario-item" [class.selected]="beneficiarioSeleccionado?.beneficiario_id === b.beneficiario_id"
          [class.pausado]="pausado(b)" [attr.aria-disabled]="pausado(b)"
          (click)="elegirBeneficiario(b)"
          style="display: flex; align-items: center; gap: 12px; padding: 14px; background: white; border: 2px solid #e5e7eb; border-radius: 12px; cursor: pointer; transition: all 0.2s;">
          <!-- Radio -->
          <div class="radio-outer" style="width: 20px; height: 20px; border-radius: 50%; border: 2px solid #d1d5db; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: border-color 0.2s;">
            <div class="radio-inner" [style.transform]="beneficiarioSeleccionado?.beneficiario_id === b.beneficiario_id ? 'scale(1)' : 'scale(0)'"
              style="width: 10px; height: 10px; border-radius: 50%; background: #1C593D; transition: transform 0.2s;"></div>
          </div>
          <!-- Avatar -->
          <div style="width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, #dcfce7, #bbf7d0); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <span style="font-size: 0.82rem; font-weight: 700; color: #1C593D;">{{ (b.beneficiario_nombre || '?')[0] | uppercase }}</span>
          </div>
          <!-- Info -->
          <div style="flex: 1; min-width: 0;">
            <p style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ b.beneficiario_nombre }} {{ b.beneficiario_apellido }}
            </p>
            <p style="font-size: 0.72rem; color: #6b7280; margin: 0; font-family: monospace;">
              {{ truncateAddress(b.beneficiario_medio_recepcion) }}
            </p>
          </div>
          <!-- Red -->
          <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0;">
            <span style="background: #f0fdf4; color: #166534; padding: 2px 8px; border-radius: 8px; font-size: 0.68rem; font-weight: 600;">
              {{ etiquetaRed(b) }}
            </span>
            <span *ngIf="pausado(b)"
              style="background: #fef3c7; color: #92400e; border: 1px solid #fde68a; padding: 1px 8px; border-radius: 8px; font-size: 0.66rem; font-weight: 700;">
              Red pausada
            </span>
          </div>
        </div>
      </div>

      <!-- Sin resultados de búsqueda -->
      <div *ngIf="listaBeneficiariosFiltrados.length === 0 && searchBeneficiario"
        style="text-align: center; padding: 20px 0; color: #6b7280; font-size: 0.82rem;">
        No se encontraron beneficiarios con "{{ searchBeneficiario }}"
      </div>

      <!-- Los de otras redes no aparecen: se dice, para que no parezcan perdidos -->
      <p *ngIf="beneficiariosOtrasRedes > 0"
        style="font-size: 0.75rem; color: #6b7280; margin: -6px 0 14px;">
        Solo ves tus beneficiarios de la red Tron (TRC20): el retiro de USDT sale por esa red.
      </p>
    </div>

    <!-- Botones -->
    <button type="button" (click)="goToStep3()"
      [disabled]="!beneficiarioSeleccionado || isTransitioning"
      [style.opacity]="(!beneficiarioSeleccionado || isTransitioning) ? '0.5' : '1'"
      [style.cursor]="(!beneficiarioSeleccionado || isTransitioning) ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s; margin-bottom: 10px;"
      onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
      Continuar
    </button>

    <button type="button" (click)="goBack()"
      [disabled]="isTransitioning"
      [style.opacity]="isTransitioning ? '0.5' : '1'"
      [style.cursor]="isTransitioning ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: all 0.2s;"
      onmouseover="if(!this.disabled)this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">arrow_back</mat-icon>
      Volver
    </button>
  </div>

  <!-- ===== STEP 3 (withdraw only): Confirmación con datos de retiro ===== -->
  <div *ngIf="step === 3" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Confirmar Compra y Retiro</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Revisa que todos los datos estén bien</p>
    </div>

    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
      <h3 style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Resumen de conversión</h3>

      <!-- Montos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Entregas</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatVESNumber(montoVes) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/flags/venezuela.png" alt="VES" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            VES
          </span>
        </div>
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Recibes</span>
          <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ formatUSDT(montoUsdt) }}</p>
          <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
            USDT
          </span>
        </div>
      </div>

      <!-- Datos de retiro -->
      <h3 style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f; margin: 14px 0 10px; padding-top: 10px; border-top: 1px solid #e5e7eb;">Datos de retiro</h3>

      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">person</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Beneficiario:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">
          {{ beneficiarioSeleccionado?.beneficiario_nombre }} {{ beneficiarioSeleccionado?.beneficiario_apellido }}
        </span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">wallet</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Wallet:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f; font-family: monospace; word-break: break-all;">
          {{ beneficiarioSeleccionado?.beneficiario_medio_recepcion }}
        </span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">hub</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Red:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">
          {{ beneficiarioSeleccionado?.medioCriptomoneda_descripcion || 'TRC20' }}
        </span>
      </div>

      <!-- Tasa y comisión -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tasa:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ formatVESNumber(tasaVesUsdt) }} VES/USDT</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">info</mat-icon>
        <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Comisión:</span>
        <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ formatPct(comisionPct) }}</span>
      </div>
    </div>

    <!-- TRC20 pausada mientras revisaba el resumen: no hay retiro posible -->
    <div *ngIf="avisoRedes" role="status"
      style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 14px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #b45309; margin-top: 1px;">pause_circle</mat-icon>
      <span style="font-size: 0.78rem; font-weight: 600; color: #92400e; line-height: 1.45;">{{ avisoRedes }}</span>
    </div>

    <!-- Botones -->
    <button type="button" (click)="confirmarCompraYRetiro()"
      [disabled]="isConverting || isTransitioning || operationCompleted || !redRetiroActiva"
      [style.opacity]="(isConverting || isTransitioning || operationCompleted || !redRetiroActiva) ? '0.5' : '1'"
      [style.cursor]="(isConverting || isTransitioning || operationCompleted || !redRetiroActiva) ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s; margin-bottom: 10px;"
      onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isConverting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
      {{ isConverting ? 'Procesando...' : 'Confirmar Compra y Retiro' }}
    </button>

    <button type="button" (click)="goBack()"
      [disabled]="isConverting || isTransitioning"
      [style.opacity]="(isConverting || isTransitioning) ? '0.5' : '1'"
      [style.cursor]="(isConverting || isTransitioning) ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: all 0.2s;"
      onmouseover="if(!this.disabled)this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">arrow_back</mat-icon>
      Volver
    </button>
  </div>

</div>
